import React from 'react';
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from 'mdbreact';

import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';

const FooterPage = () => (
  <MDBFooter
    color='elegant-color-dark'
    className='font-small darken-3 pt-0 mt-4'
  >
    <MDBContainer>
      <MDBRow>
        <MDBCol md='12' className='py-3'>
          <div className='mb-5 flex-center'>
            <a href='https://www.facebook.com/nssiith/' className='fb-ic'>
              <i className='fab fa-facebook-f fa-lg white-text mr-md-5 mr-3 fa-2x' />
            </a>
            <a
              href='https://www.instagram.com/nss_iithyderabad/'
              className='ins-ic'
            >
              <i className='fab fa-instagram fa-lg white-text mr-md-5 mr-3 fa-2x' />
            </a>
            {/* <a href="https://nssiithyd.wordpress.com/" className="wp-ic">
              <i className="fab fa-wordpress fa-lg white-text mr-md-5 mr-3 fa-2x">
                {' '}
              </i>
            </a> */}
            <a href='https://goo.gl/maps/Lqz15QANCabr7zXY9' className='mp-ic'>
              <i className='fa fa-map-marker-alt fa-lg white-text mr-md-5 mr-3 fa-2x'>
                {' '}
              </i>
            </a>
          </div>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
    <div className='footer-copyright text-center py-3'>
      <MDBContainer fluid>
        &copy; {new Date().getFullYear()} Copyright:{' '}
        <a href='http://nss.iith.ac.in'>
          {' '}
          NSS 2020, IIT Hyderabad | All Rights Reserved{' '}
        </a>
      </MDBContainer>
    </div>
  </MDBFooter>
);

export default FooterPage;
